import React from "react";

import { useGetRelatedArticles, useTranslation, useUserContext } from "utils";

import { ArticleCard, Carousel, Col, IconLinkButton, Row } from "components";

type RelatedArticlesProps = {
  link: string;
  carousel?: boolean;
};

export const RelatedArticles = ({ carousel, link }: RelatedArticlesProps) => {
  const { t } = useTranslation(["articles"]);
  const { user } = useUserContext();

  const { articles, articleIsLoading: loading } = useGetRelatedArticles({ link });

  return (
    !loading &&
    articles.length && (
      <>
        {carousel ? (
          // @ts-expect-error need to convert to tsx
          <Carousel inDrawer type="mini">
            {articles.map((article) => (
              <ArticleCard key={article.id} link={article.link} />
            ))}
          </Carousel>
        ) : (
          <>
            <Row className="margin-top-450 margin-bottom-100">
              <Col>
                <IconLinkButton
                  size="large"
                  iconType="arrow"
                  text={t("post.related")}
                  mixpanelText={t("post.related")}
                  href={user ? "/search/knowledge" : "/search"}
                />
              </Col>
            </Row>
            <Row>
              {/* prelint-ignore-col */}
              {articles.map((article) => (
                <Col sm={24} md={8} key={article.id}>
                  <ArticleCard link={article.link} />
                </Col>
              ))}
            </Row>
          </>
        )}
      </>
    )
  );
};
